import { getConfig } from '@edx/frontend-platform'


/*
    *@params:
        courseIds: an array of openedx course ids
        coursesDataFetched: learnerHomeInitData from useLearnerHomeInit()
*/

export const getCoursesBasedOnCourseIdsEnrolled = (courseIds, coursesDataFetched) => {
    const lmsBaseUrl = getConfig().LMS_BASE_URL;

    const courses = coursesDataFetched.courses;
    const courseDescriptions = coursesDataFetched.courseDescriptions;

    return courses.filter(course => courseIds.includes(course.courseRun.courseId)).map(course => {
        const parsedCourse = {}

        parsedCourse.courseId = course.courseRun.courseId; // courseId
        Object.assign(parsedCourse, course.course) // courseDescription, bannerImgSrc, courseName, courseNumber
        parsedCourse.bannerImgSrc = `${lmsBaseUrl}${parsedCourse.bannerImgSrc}` // bannerImgSrc
        parsedCourse.resumeLink = course.courseRun.resumeUrl ? lmsBaseUrl + course.courseRun.resumeUrl : null; // resumeLink
        parsedCourse.homeLink = course.courseRun.homeUrl ? course.courseRun.homeUrl : null; // homeLink
        parsedCourse.description = courseDescriptions[course.courseRun.courseId] // description
        parsedCourse.startDate = course.courseRun.startDate ? course.courseRun.startDate : null; // startDate

        return parsedCourse;
    })
}